export default __webpack_public_path__ + "static/media/hht1_ep03_timeline_q05_b.f35bbb74.png";